<template>
  <v-card>
    <v-card-title>
      Membership Plans
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="packages" :search="search">
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.locations }}</td>
        <td>{{ props.item.projects }}</td>
        <td>{{ props.item.expertise }}</td>
        <td>
          <v-btn color="btnColor" @click="showOptionsModal(props.item)" flat>View Options</v-btn>
        </td>
        <td>
          <v-btn color="btnColor" @click="showFeaturesModal(props.item)" flat>View Features</v-btn>
        </td>
        <td>
          <v-btn flat @click="optionModal(props.item)">
            <v-icon color="orange">add</v-icon>
          </v-btn>
        </td>
        <td>
          <v-btn flat @click="featureModal(props.item)">
            <v-icon color="orange">add</v-icon>
          </v-btn>
        </td>
        <td>
          <v-btn icon @click="editModal(props.item)" flat>
            <v-icon color="orange darken-2">edit</v-icon>
          </v-btn>
        </td>
        <td>
          <v-btn icon @click="deleteModal(props.item)" flat>
            <v-icon color="red">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- add feature -->
    <v-dialog v-model="addFeatureModal" max-width="600px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Add Feature</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="addFeatureModal = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <center>
          <h3>{{dataItem.name}}</h3>
        </center>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field v-model="featureName" label="Feature"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn class="primary" small @click="saveFeature">
                <v-icon>save</v-icon>Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end -->

    <!-- add option -->
    <v-dialog v-model="addOptionModal" max-width="600px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Add Option</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="addOptionModal = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <center>
          <h3>{{dataItem.name}}</h3>
        </center>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field v-model="optionData.time" label="Time"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="optionData.cost" label="Cost(KES)"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="optionData.cost_usd" label="Cost(USD)"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="optionData.duration" label="Duration"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn class="primary" small @click="saveOption">
                <v-icon>save</v-icon>Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end  -->

    <!-- Sub options dialog -->
    <v-dialog v-model="optionsModal" max-width="600px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Package Options</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="optionsModal = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <center>
          <h3>{{option.name}}</h3>
        </center>
        <v-data-table :headers="optionsHeaders" :items="option.options">
          <template v-slot:items="props">
            <td>{{ props.item.time }}</td>
            <td>{{ props.item.cost}}</td>
            <td>{{ props.item.duration}}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- End of options dialog-->

    <!-- Sub options dialog -->
    <v-dialog v-model="featuresModal" max-width="600px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Package Features</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="featuresModal = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <center>
          <h3>{{option.name}}</h3>
        </center>
        <v-data-table :headers="featuresHeaders" :items="feature.features">
          <template v-slot:items="props">
            <td>{{ props.item}}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- End of options dialog-->

    <!-- delete dialog -->
    <v-dialog v-model="deleteDialog" max-width="600px">
      <v-toolbar flat dense color="red" dark>
        <v-toolbar-title class="title">Delete Package</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="deleteDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12>
            <v-text-field v-model="dataItem.name" label="Package Name"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn color="red" dark :loading="loader" @click="deletePackage">Delete</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of delete dialog-->

    <!-- option dialog -->
    <v-dialog v-model="optionDialog" max-width="500px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Option</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="optionDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12>
            <v-text-field v-model="optionItem.time" label="Time"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="optionItem.cost" label="Cost(KES)"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="optionItem.cost_usd" label="Cost(USD)"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="optionItem.duration" label="Duration"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" dark :loading="loader" @click="updateOption">Update</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of option dialog-->

    <!-- feature dialog -->
    <v-dialog v-model="featureDialog" max-width="500px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Feature</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="featureDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12>
            <v-text-field label="Feature" v-model="featureItem" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" dark :loading="loader" @click="updateFeature">Update</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of feature dialog-->

    <!-- Edit dialog -->
    <v-dialog v-model="editDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Package</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="editDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap class="pa-3">
            <v-flex xs3>
              <v-text-field v-model="dataItem.name" label="Package Name"></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field v-model="dataItem.locations" label="Locations"></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field v-model="dataItem.projects" label="Projects"></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field v-model="dataItem.expertise" label="Expertise"></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-switch
              label="Accept USD Payment"
              color="primary"
              v-model="dataItem.enable_usd"
            ></v-switch>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                v-validate="'required'"
                :error-messages="errors.collect('description')"
                data-vv-name="description"
                v-model="dataItem.description"
                name="description"
                label="About the package"
                required
              ></v-textarea>
            </v-flex>

            <v-flex xs12>
              <h4>Options</h4>
              <v-data-table :headers="eoptionsHeaders" :items="dataItem.options">
                <template v-slot:items="props">
                  <td>{{ props.item.time }}</td>
                  <td>{{ props.item.cost}}</td>
                  <td>{{ props.item.cost_usd}}</td>
                  <td>{{ props.item.duration}}</td>
                  <td>
                    <v-btn flat @click="optionModal(dataItem)">
                      <v-icon color="orange">add</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-btn @click="editOption(props.item, dataItem)" small flat icon class="warning--text">
                      <v-icon color="orange">edit</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-btn @click="deleteOption(props.item)" small flat icon class="warning--text">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>

            <v-flex xs12>
              <h4>Features</h4>
              <v-data-table :headers="efeaturesHeaders" :items="dataItem.features">
                <template v-slot:items="props">
                  <td>{{ props.item}}</td>
                  <td>
                    <v-btn flat @click="featureModal(dataItem)">
                      <v-icon color="orange">add</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-btn @click="editFeature(props.item, dataItem, dataItem.features.indexOf(props.item))" small flat icon class="warning--text">
                      <v-icon color="orange">edit</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-btn @click="deleteFeature(props.item)" small flat icon class="warning--text">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>

            <v-flex xs12>
              <v-btn color="primary" :loading="loader" @click="updatePackage">Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- End of edit dialog-->
  </v-card>
</template>

<script>
export default {
  props: {
    packages: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      search: "",
      optionsModal: false,
      addFeatureModal: false,
      addOptionModal: false,
      featuresModal: false,
      deleteDialog: false,
      optionDialog: false,
      editDialog: false,
      featureDialog: false,
      dataItem: {},
      featureItem: '',
      optionItem: {},
      optionData: {},
      loader: false,
      option: {},
      featureName: null,
      feature: {},
      headers: [
        {
          text: "Package Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Locations",
          align: "left",
          sortable: false,
          value: "locations"
        },
        {
          text: "Projects",
          align: "left",
          sortable: false,
          value: "projects"
        },
        {
          text: "Expertise",
          align: "left",
          sortable: false,
          value: "expertise"
        },
        {
          text: "Action",
          align: "left",
          sortable: false,
          value: "options"
        },
        { text: "Action", value: "features" },
        { text: "Option", value: "addOption" },
        { text: "Feature", value: "addFeature" },
        { text: "Action", value: "edit" },
        { text: "Action", value: "delete" }
      ],
      optionsHeaders: [
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "time"
        },
        {
          text: "Cost",
          align: "left",
          sortable: false,
          value: "cost"
        },
        {
          text: "Duration",
          align: "left",
          sortable: false,
          value: "duration"
        }
      ],
      featuresHeaders: [
        {
          text: "Feature",
          align: "left",
          sortable: false,
          value: "feature"
        }
      ],
      eoptionsHeaders: [
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "time"
        },
        {
          text: "Cost (KES)",
          align: "left",
          sortable: false,
          value: "cost"
        },
        {
          text: "Cost (USD)",
          align: "left",
          sortable: false,
          value: "cost"
        },
        {
          text: "Duration",
          align: "left",
          sortable: false,
          value: "duration"
        },
        {
          text: "Add",
          align: "left",
          value: "add"
        },
        {
          text: "Action",
          align: "left",
          value: "edit"
        },
        {
          text: "Delete",
          align: "left",
          value: "delete"
        }
      ],
      efeaturesHeaders: [
        {
          text: "Feature",
          align: "left",
          sortable: false,
          value: "feature"
        },
        {
          text: "Add",
          align: "left",
          value: "add"
        },
        {
          text: "Action",
          align: "left",
          value: "edit"
        },
        {
          text: "Delete",
          align: "left",
          value: "delete"
        }
      ],
      packageItem: {},
      featurePosition: 0,
    };
  },
  methods: {
    featureModal(item) {
      this.dataItem = Object.assign({}, item);
      this.addFeatureModal = true;
    },
    optionModal(item) {
      this.dataItem = Object.assign({}, item);
      this.addOptionModal = true;
    },
    editOption(item, packageItem) {
      this.optionItem = Object.assign({}, item);
      this.optionDialog = true;
      this.packageItem = Object.assign({}, packageItem);
    },
    deleteFeature(item) {
      const index = this.dataItem.features.indexOf(item);
      this.dataItem.features.splice(index, 1);
    },
    deleteOption(item) {
      const index = this.dataItem.options.indexOf(item);
      this.dataItem.options.splice(index, 1);
    },
    deleteModal(item) {
      this.dataItem = item;
      this.deleteDialog = true;
    },
    editModal(item) {
      this.dataItem = item;
      this.editDialog = true;
    },
    updateOption() {
      const optionRecord = this.optionItem;
      const option = this.dataItem.options.find(record => {
        return record._id === optionRecord._id;
      });
      const pos = this.dataItem.options.indexOf(option);
      if (pos === -1) {
        return;
      }
      option.cost = optionRecord.cost;
      option.cost_usd = optionRecord.cost_usd;
      option.duration = optionRecord.duration;
      option.time = optionRecord.time;
      this.dataItem.options[pos] = option;
      this.optionDialog = false;
    },
    deletePackage() {
      const data = this.dataItem;
      this.loader = true;
      this.$store
        .dispatch("post", { url: "/packages/delete/" + data._id })
        .then(res => {
          self.loader = false;
          self.deleteDialog = false;
        })
        .finally(() => {
          location.reload();
        });
    },
    updatePackage() {
      const data = this.dataItem;
      this.loader = true;
      this.$store
        .dispatch("post", { data: data, url: "/packages/update/" + data._id })
        .then(res => {
          self.loader = false;
          self.editDialog = false;
        })
        .finally(() => {
          location.reload();
        });
    },
    saveFeature() {
      const feature = this.featureName;
      this.dataItem.features.push(feature);
      const data = this.dataItem;
      this.loader = true;
      this.$store
        .dispatch("post", { data: data, url: "/packages/update/" + data._id })
        .then(res => {
          self.loader = false;
          self.addFeatureModal = false;
        })
        .finally(() => {
          location.reload();
        });
    },
    saveOption() {
      const optionData = this.optionData;
      this.dataItem.options.push(optionData);
      const data = this.dataItem;
      this.loader = true;
      this.$store
        .dispatch("post", { data: data, url: "/packages/update/" + data._id })
        .then(res => {
          self.loader = false;
          self.addOptionModal = false;
        })
        .finally(() => {
          location.reload();
        });
    },
    showOptionsModal(item) {
      this.option = item;
      this.optionsModal = true;
    },
    showFeaturesModal(item) {
      this.feature = item;
      this.featuresModal = true;
    },
    closeOptionsModal() {},
    editFeature(item, packageItem, itemPosition) {
      this.featureItem = item;
      this.featureDialog = true;
      this.packageItem = Object.assign({}, packageItem);
      this.featurePosition = itemPosition;
    },
    updateFeature() {
      const pos = this.featurePosition;
      if (pos === -1) {
        return;
      }
      this.dataItem.features[pos] = this.featureItem;
      this.featureDialog = false;
    },
  }
};
</script>